<template>
	<div>
    <div style="position: sticky; top:12px; z-index: 200;">
			<Breadcrumbs :items="items" />
		</div>
		<v-container fluid class="px-10">
      <v-row no-gutters align="center" class="mt-3 mb-3">
				<v-icon color="primary mr-9" class="mr-4">mdi-play</v-icon>
				<span class="title font-weight-regular primary--text" v-translate key="start">Begin</span>
			</v-row>
      <v-divider class="my-5"></v-divider>
			<v-row no-gutters class="mt-5">
        <template v-for="(item, i) in general">
          <v-col v-if="item.permition" :key="i" cols="12" md="4" class="px-2 mb-5">
            <v-card
              height="84px"
              :to="item.to"
              shaped
              :style="$store.getters.tourStep == item.tourStep ? {'position': 'relative', 'z-index': 400, 'background': '#FFFFFF'} : ''"
            >
              <v-card-title>
                <v-icon color="primary" class="mr-3">{{item.icon}}</v-icon>
                <span
                  class="font-weight-regular"
                  :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'"
                  >{{ item.name }}</span
                >
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </template>
			</v-row>
      <template v-if="$store.getters.hasRole('terapeut') && hasTreatments">
        <v-row no-gutters align="center" class="mt-3 mb-3">
          <v-icon color="primary mr-9" class="mr-4">mdi-book-open-variant</v-icon>
          <span class="title font-weight-regular primary--text" v-translate key="library">Library</span>
        </v-row>
        <v-divider class="my-5"></v-divider>
        <v-row no-gutters>
          <template v-for="(treatment, i) in treatments">
            <v-col v-if="treatment.permition" :key="i" cols="12" md="4" class="px-2 mb-5">
              <v-card
                height="84px"
                :to="treatment.to"
                :disabled="treatment.to ? false : true"
                shaped
              >
                <v-card-title>
                  <v-icon color="primary" class="mr-3">{{treatment.icon}}</v-icon>
                  <span
                    class="font-weight-regular"
                    :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'"
                    >{{ treatment.name }}</span
                  >
                </v-card-title>
                <v-card-actions></v-card-actions>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </template>
      <template v-if="$store.getters.hasRole('terapeut')">
        <v-row no-gutters align="center" class="mt-3 mb-3">
          <v-icon color="primary mr-9" class="mr-4">mdi-application-cog</v-icon>
          <span class="title font-weight-regular primary--text" v-translate key="library">Customize</span>
        </v-row>
        <v-divider class="my-5"></v-divider>
        <v-row no-gutters>
          <v-col v-for="item in customizeItems" :key="item.name" cols="12" md="4" class="px-2 mb-5">
            <v-card
              height="84px"
              :to="item.to"
              :disabled="item.to ? false : true"
              shaped
            >
              <v-card-title>
                <v-icon color="primary" class="mr-3">{{item.icon}}</v-icon>
                <span
                  class="font-weight-regular"
                  :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'"
                  >{{ item.name }}</span>
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <v-row no-gutters align="center" class="mt-3 mb-3">
        <v-icon color="primary mr-9" class="mr-4">mdi-cogs</v-icon>
        <span class="title font-weight-regular primary--text" v-translate key="library">Administration</span>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <v-row no-gutters>
        <template v-for="(other, i) in others">
          <v-col v-if="other.permition" :key="i" cols="12" md="4" class="px-2 mb-5">
            <v-card
              height="84px"
              :to="other.to"
              shaped
            >
              <v-card-title>
                <v-icon color="primary" class="mr-3">{{other.icon}}</v-icon>
                <span
                  class="font-weight-regular"
                  :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'"
                  >{{ other.name }}</span
                >
              </v-card-title>
              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </template>
        <v-col v-if="$store.getters.hasAnyModule && $store.getters.hasRole('terapeut')" key="tour" cols="12" md="4" class="px-2 mb-5">
          <v-card
            height="84px"
            shaped
            @click="beginTour"
          >
            <v-card-title>
              <v-icon color="primary" class="mr-3">mdi-television-play</v-icon>
              <span
                class="font-weight-regular"
                :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'text-h6'"
                >Tutorial</span
              >
            </v-card-title>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import { mapGetters } from 'vuex'

export default {
  name: "Home",
  components: {
    Breadcrumbs
  },
	data: () => ({}),
  computed: {
    items() {
			return [
				{text: this.$gettext("Dashboard"), disabled: false, link: true, to: { name: "home" }}
			]
    },
    general() {
      return [
        {name: this.$gettext("New Appointment"), icon: "mdi-calendar-plus", to: {name: 'calendar', params: {showNewAppointment: true}}, permition: this.$store.getters.canCreateAppointment, tourStep: 'dashboard-new-appointment'},
        {name: this.$gettext("Schedule"), icon: "calendar_today", to: {name: 'calendar'}, permition: true, tourStep: 'dashboard-schedule'},
        {name: this.$gettext("Patients"), icon: "mdi-account-group", to: {name: 'patients'}, permition: true, tourStep: 'dashboard-patients'},
        {name: this.$gettext("Monitoring"), icon: "mdi-chart-line", to: {name: 'monitoring'}, permition: this.$store.getters.hasRole("terapeut"), tourStep: 'dashboard-monitoring'}
      ]
    },
    treatments() {
      return [
        {name: this.$gettext("Supplements"), to: { name: 'supplements' }, icon: "mdi-pill", permition: this.$store.getters.hasModule("fito")},
        {name: this.$gettext("Chinese Materia Medica"), to: { name: 'cmm' }, icon: "mdi-beaker-outline", permition: this.$store.getters.hasModule("mtc")},
        {name: this.$gettext("ICD-11"), to: { name: 'icd' }, icon: "mdi-barcode", permition: this.$store.getters.hasAnyModule},
        //{name: this.$gettext("Acupuncture"), to: {name: "acupuncture"}, icon: "$vuetify.icons.acuIcon", permition: this.$store.getters.hasModule("mtc")},
      ]
    },
    others() {
      return [
        {name: this.$gettext("Subscriptions"), icon: "add_to_queue", to: {name: 'modules'}, permition: this.$store.getters.hasRole("manager")},
        {name: this.$gettext("Invite Friends"), icon: "mdi-account-multiple-plus", to: {name: 'modules', params: {openReferral: true}}, permition: this.$store.getters.hasRole("manager")},
        {name: this.$gettext("Settings"), icon: "settings", to: {name: 'settings'}, permition: true},
        {name: this.$gettext("Support"), icon: "help", to: {name: 'support'}, permition: true}
      ]
    },
    customizeItems() {
      return [
        {name: this.$gettext("Tests"), icon: "assessment", to: {name: 'tests'}, permition: true},
        {name: this.$gettext("Treatments"), icon: "mdi-clipboard-text", to: {name: 'treatments'}, permition: true}
      ]
    },
    hasTreatments() {
      for(let i = 0; i < this.treatments.length; i++) {
        if(this.treatments[i].permition) return true;
      }
      return false;
    },
    ...mapGetters({
      tourStep: 'tourStepEvent'
    })
  },
  methods: {
    beginTour() {
			this.$store.dispatch('BEGIN_TOUR');
      window.scrollTo(0, 0);
			//this.$router.push({name: 'calendar'});
		}
  },
  watch: {
    tourStep(value) {
			if(value == 'tour-go-to-new-appointment') {
				this.$router.push({name: 'calendar', params: {showNewAppointment: true}});
			}
		}
  }
};
</script>